import type { FC, ReactElement } from 'react';

import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { useConfigSlice } from '../../../store/slices/config/selectors';
import { redirectParentIframe } from '../../../utils/redirect';
import { Button, ButtonVariant } from '../../controls/button/Button';

import { BlockingModalContent } from './BlockingModalContent';

export const SessionTerminatedConnected: FC = (): ReactElement => {
  const homeUrl = useConfigSlice.casinoConfig()?.homeUrl;

  const action = homeUrl
    ? [<Button key="OK" tk="OK" variant={ButtonVariant.ACCENT} onClick={() => redirectParentIframe(homeUrl)} />]
    : [];

  return (
    <BlockingModalContent title={<L10nText tk="POPUP_ACCOUNT_RESTRICTED" />} actions={action}>
      <L10nText tk="POPUP_TEXT_CONTACT_SUPPORT" />
    </BlockingModalContent>
  );
};
